import { useContext, createContext, useEffect, useState } from 'react';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  onIdTokenChanged
} from 'firebase/auth';
import requestHandler from '../utils/requestHandler';
import { auth } from '../firebase';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const googleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };

  const logOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Sign Out Error:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(auth, async (firebaseUser) => {
      try {
        if (!firebaseUser) {
          setUser(null);
          setLoading(false);
          return;
        }

        const token = await firebaseUser.getIdToken();

        let result = {};
        try {
          result = await requestHandler(
            `users/${firebaseUser.email.split("@")[0]}`,
            "GET",
            "Bearer " + token
          );
        } catch (apiError) {
          console.error("Backend profile could not be loaded, user might be new:", apiError);
        }

        const enrichedUser = {
          ...firebaseUser,
          profile: result || {},
          accessToken: token,
          isAdmin: Boolean(result?.groups && result.groups.includes("Admins")),
          permissions: result?.permissions || [],
          allowedUI: result?.allowedUI || [],
          statute: result?.statute
        };

        setUser(enrichedUser);
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  return (
    <AuthContext.Provider value={{ googleSignIn, logOut, user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => useContext(AuthContext);
